<template>
  <div class="page">
    <div v-for="(item, i) in data">
      <div class="margin-top" v-if="item.strong == true">
        <strong> {{ item.title }}</strong>
      </div>
      <div class="margin-top" v-else>{{ item.title }}</div>
    </div>
    <div class="right">北京技能码科技有限公司</div>
  </div>
</template>

<script>
export default {
  name: "SkillPrivatepolicy",
  data() {
    return {
      data: [
        { title: "亲爱的用户，您好：" },
        {
          title:"技能码是由北京技能码科技有限公司（下称技能码）基于职业教育求职信息开发的应用产品。技能码非常重视您的个人信息或个人数据信息。在您仔细阅读、了解并同意本政策之前，不要向技能码提交任何个人信息、数据等隐私信息（下称“信息”）。如果您是未成年人，应当与父母或监护人共同审阅本协议，以确保您及您的父母或监护人了解本协议。" 
        },
        {title:"请注意，本政策是技能码针对信息处理和保护的主要策略，但本政策可能无法解决您的信息处理和保护的所有问题，因此技能码会针对某些特定服务提供特定隐私政策作为本政策的补充，以便在基于特定目的处理和保护您的信息时通知客户，请您在使用技能码产品或服务时，注意其他形式的此类通知。"},
        { title: "1.技能码如何收集及使用您的信息", strong: true },
        { title: "1.1个人注册信息", strong: true },
        { title: "当您注册技能码账号时，我们会根据您的选择收集您的手机号，以帮助完成账号相关权益的保存。您还可以根据自身需求上传头像、昵称等信息。"},
        { title: "请您妥善保管您的账号、密码，如您将密码告知他人、与他人共享注册账户或其他个人保管不善事由导致的任何个人信息泄露、丢失、被盗用或被篡改等，技能码不对此承担责任。"},
        { title: "1.2获取设备权限",strong: true},
        { title: "1.2.1网络权限",strong: true},
        { title: "我们需要在得到您的同意后，获取您的网络连接，主要用于内容的获取、视频的播放及消息的通知。",strong: false},
        { title: "1.2.2相机权限",strong: true},
        { title: "我们需要在得到您的同意后，连接您的相机功能，主要用于根据个人需要的图片上传及好友二维码的识别。",strong: false},
        { title: "1.2.3语音权限",strong: true},
        { title: "我们需要在得到您的同意后，打开您的麦克风，用于应用中的语音互动功能的使用。",strong: true},
        { title: "1.2.4位置权限",strong: true},
        { title: "我们需要在得到您的同意后，获取您的位置，用于提供基于位置的互动服务的使用。",strong: false},
        { title: "1.3收集设备信息",strong: true},
        { title: "技能码会收集某些信息进行统计与分析，这类信息包括您的设备名称、设备的粗略地理位置信息 (例如设备所在的网络位置编码)、运营商网络ID(PLMN)、应用使用情况、您访问互联网的IP地址、IP设备存储。技能码收集并处理这类信息的唯一目的是：改善我们的产品、分析我们的运营效率、统计市场占有率、改善网络和服务的安全性，以及启用您的保障服务。",strong: false},
        { title: "1.4第三方SDK信息",strong: true},
        { title: "1.4.1华为推送、华为联运应用、阿里推送",strong: true},
        { title: "以上SDK用于应用中聊天消息提醒、信息提醒等功能的使用，其中，华为推送会获取您的安装应用列表，用于APP未启动时的消息推送。",strong: false},
       { title: "1.4.2腾讯浏览器",strong: true},
       { title: "用于应用中相关H5页面浏览功能的使用。",strong: false},
       { title: "1.4.3腾讯Bugly",strong: true},
       { title: "用于应用中技术问题的监控与防范。",strong: false},
       { title: "1.4.4友盟",strong: true},
       { title: "友盟会收集您的IMEI、ICCID信息、软件安装列表、MAC地址，用于用户及其浏览信息的分析，便于提供更佳的用户体验。",strong: false},
          { title: "1.4.5微信",strong: true},
           {title:'用于提供APP分享服务，便于用户将相关内容页面分享到第三方平台。',strong: false},
            {title:'https://open.weixin.qq.com/cgi-bin/frame?t=news/protocol_developer_tmpl',strong: false},
          { title: "1.4.6微博",strong: true},
          {title:'用于提供APP分享服务，便于用户将相关内容页面分享到第三方平台。',strong: false},
           {title:'第三方隐私政策链接：https://m.weibo.cn/c/privacy?from=h5',strong: false},
           { title: "1.4.7百度地图",strong: true},
           {title:'用于地图显示、获取位置信息、导航、地址搜索，便于用户在求职过程查看公司地理位置（经纬度、精确位置、粗略位置）和路程距离。',strong: false},
           {title:'第三方隐私政策链接：https://lbsyun.baidu.com/index.php?title=openprivacy',strong: false},
         { title: "1.5 去标识化信息的收集及使用",strong: true},
         { title: "“去标识化信息”是指无法识别特定个人身份的信息，例如我们应用的启动次数、页面的点击次数。技能码会收集这类信息，以了解用户如何使用我们的应用、产品或服务，如此技能码才能进行改善，以满足客户的需求。技能码可以自行决定是否基于任何其他目的，收集、使用、移转或披露非个人信息。",strong: false},
        { title: "1.6 MAC权限",strong: true},
         { title: "我们需要在得到您的同意后，获取应用安装设备的唯一MAC地址，帮您在未登录状态下记录收藏信息，并将信息同步于登录的账号，方便后续使用。",strong: false},
         {title: "1.7 Uni",strong: true},
          { title: "我们的产品基于DCloud uni-app(5+ App/Wap2App)开发，应用运行期间需要收集您的设备唯一识别码（IMEI/android ID/DEVICE_ID/IDFA、SIM 卡 IMSI 信息、OAID）以提供统计分析服务，并通过应用启动数据及异常错误日志分析改进性能和用户体验，为用户提供更好的服务。详情内容请访问《DCloud用户服务条款》。(DCloud用户服务条款超链至：https://ask.dcloud.net.cn/protocol.html)",strong: false},
         { title: "2.技能码如何披露您的信息",strong: true},
         { title: "只有符合下列情况时，技能码才会披露您的信息。在下列情形之外，技能码绝不会将您的信息披露给第三方。",strong: false},
         { title: "2.1您已明确同意",strong: true},
         { title: "在得到您的批准后，技能码才会将您的信息透露给其他公司。",strong: false},
         { title: "2.2将您的信息披露给技能码关联公司或授权合作的第三方",strong: true},
         { title: "技能码可能需要通过某些合作方为您提供某些服务，因此技能码需要将您的部分信息共享给合作方，以便丰富我们的服务以及满足您的需求。",strong: false},
         { title: "2.3依法律要求，披露您的信息",strong: true},
         { title: "依法律、法院等司法机关命令或其他法律程序的规定，或相关政府机关的要求，技能码可能会提供您的信息。在技能码涉及重组、合并或清算的情况下，您的信息可能也会提供给交易方。",strong: false},
         { title: "3.技能码如何更新、变更或检查您的信息",strong: true},
         { title: "您应该对所提交的信息的准确性负责，技能码将尽到商业上合理的努力，确保您信息的准确性。",strong: false},
         { title: "4.技能码如何保护您的信息",strong: true},
         { title: "技能码采取合理的预防措施，包括但不限于物理上、技术及制度等方面，以保护您的信息不会遭受未经授权的浏览、披露、滥用、变更、破坏以及损失。例如，在技术方面，技能码使用防病毒软件、加密保护监控我们的系统，以及增强我们数据中心的攻击防护；物理方面，技能码设定门禁措施及访问控制，仅允许需要这类信息的业务人员浏览；在制度方面，则通过对技能码员工进行安全与隐私保护知识培训，确保员工了解保护数据的重要性。虽然我们采用合理的措施来保护您的个人数据，但没有任何安全措施能够百分之百完美或牢不可破。但由于黑客攻击、计算机病毒侵入或发作、因政府管制而造成的暂时性关闭等影响网络正常经营之不可抗力而导致您的信息泄露、丢失、被盗用或被篡改的，技能码无需承担责任，但应采取补救措施，按照规定及时告知您并向有关主管部门报告。",strong: false},
         { title: "此外，您可以在我们的产品中直接申请注销账户。您可以通过在APP内访问我的--设置--注销账号--完成账号注销。关于您注销账户的方式以及您应满足的条件，请详见《账号注销须知》。您注销账号后，我们将停止为您提供产品与/或服务，并依据您的要求，除法律法规另有规定外，我们将删除您的个人信息。",strong: false},
         { title: "5.技能码如何处理未成年人的信息",strong: true},
         { title: "技能码鼓励父母或监护人指导未成年人使用技能码的产品或服务。如果法律有相关规定，技能码不会在未征得监护人同意的前提下收集未成年人的信息。我们只会在法律允许的范围内，或依当地法律取得监护人的同意，或是为保护未成年人而使用或披露有关未成年人的信息。「未成年人」的定义应考虑适用的法律，以及各国家和地区的文化惯例。",strong: false},
         { title: "若您是未成年人的监护人，请您关注您监护的未成年人是否是在取得您的授权同意之后使用技能码的产品或服务。如果您对您所监护的未成年人的个人信息有疑问，请通过第10条中的联系方式与我们联系。",strong: false},
         { title: "6.第三方服务提供商",strong: true},
         { title: "为方便您的访问并丰富您的体验，可能会有非技能码的第三方提供内容或网络链接。您可以选择是否访问这类链接或内容，是否使用这类第三方的服务或产品，但技能码对于这些并没有控制权。技能码无法控制第三方的任何隐私权和数据保护措施，这类措施不受本政策管理，本政策也不适用于您自行选择提供给第三方的任何信息，请您在使用这类第三方的服务或产品时查看第三方的隐私保护政策。",strong: false},
         { title: "7.信息传输",strong: true},
         { title: "技能码产品与服务可能会由位于世界不同国家或地区的资源与服务器提供。因此，您的信息可能会跨国界而传输到您使用我们服务所在国家或地区之外的国家和地区，那些国家或地区可能没有对信息提供具体保护的法律，或是实行不同的数据保护法。在这类情况下，技能码将采取措施，确保有法律基础可进行这类传输，以及依适用法律，会对您信息提供适当的保护，例如，通过使用相关授权单位核准的标准合约（必要时），以及通过使用其他适当的技术与信息安全措施。",strong: false},
         { title: "8.本隐私政策的更新",strong: true},
         { title: "技能码可能会不定期修订本《隐私政策》的条款，技能码将通过产品更新，告知您通知您，请您更新最新版本的技能码产品查询修订后的《隐私政策》。在该种情况下，若您继续使用技能码的产品或服务，即表示同意受修订后的《隐私政策》的约束。",strong: false},
         { title: "9.其他",strong: true},
         { title: "本隐私政策是技能码统一适用的一般性隐私条款，其中所规定的用户权利及信息安全保障措施均适用于技能码用户。",strong: false},
         { title: "10.与技能码联络",strong: true},
         { title: "如果您有任何问题、意见或建议，以及要求删除后台的用户数据，您可以发邮件到hzf-4c8ml7ncz@dingtalk.com与我们联络。",strong: false},
         { title: "技能码保留本政策条款之解释权。",strong: false},
         {title:"更新日期: 2023-12-18"}
           
      ]
      
    };
  },
  methods: {},
  created() {},
  mounted() {}
};
</script>
<style scoped>
.page {
  display: block;
  width: 6.9rem;
  margin-left: 0.3rem;
  margin-right: 0.3rem;
  /* padding-right: 0.3rem;
  padding-left: 0.3rem; */
}

div {
  color: #666;
  font-size: 0.34rem;
  text-align: left;
  width: 100%;
  line-height: 0.6rem;
  font-weight: normal;
  letter-spacing: 1px;
}

.margin-top {
  margin-top: 0.3rem;
}

.center {
  font-size: 0.36rem;
  margin-top: 0.6rem;
  margin-bottom: 0.6rem;
  text-align: center;
  color: #000;
}

.right {
  font-size: 0.36rem;
  color: #666;
  width: 100%;
  margin-top: 0.6rem;
  float: right;
  text-align: right;
  margin-bottom: 0.6rem;
  display: block;
}
</style>


// WEBPACK FOOTER //
// src/components/JnmPrivacyPolicy.vue